import { Box, Skeleton, SkeletonText } from 'src/theme'

export default function Loading () {
  return (
    <>
      <Skeleton height={260} />
      <Box p={6}>
        <SkeletonText
          noOfLines={1}
          skeletonHeight={6}
          mb={6}
        />
        <SkeletonText noOfLines={4} />
      </Box>
    </>
  )
}
